<div class="w-full flex flex-col gap-4 p-4">
    <h1 class="text-2xl font-bold">Empresas</h1>

    <app-input-search
        [(ngModel)]="filtro"
        label="Pesquisar Empresa"
        (keydown.enter)="filtrar()"
        (search)="filtrar()"
        class="w-full"
    ></app-input-search>

    <p-table
        (onPage)="paginator($event)"
        [paginator]="true"
        [rows]="qtdLinhas || 10"
        [rowsPerPageOptions]="opcoesLinhas"
        [totalRecords]="totalItens"
        [value]="lista"
        [lazy]="true"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[35%] min-w-10">Empresa</th>
                <th class="w-[15%] min-w-10">CNPJ</th>
                <th class="w-[20%] min-w-10">Nome Fantasia</th>
                <th class="w-[25%] min-w-10"></th>
                <th class="w-[5%] min-w-5">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.RAZAO_SOCIAL }}</td>
                <td>{{ rowData.CPF_CNPJ | cpfCnpj }}</td>
                <td>{{ rowData.NOME_FANTASIA }}</td>
                <td>
                    <div
                        class="w-full flex flex-col items-center justify-center"
                    >
                        <app-button class="w-full md:max-w-45" (click)="acessarToqWeb(rowData)" size="sm">
                            Acessar
                        </app-button>
                    </div>
                </td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
